import { Collapse } from 'antd';
import API from 'API';
import { NotFound } from 'AppRoute';
import { Essay } from 'components/general/StudentExercises';
import FullMask from 'components/layout/FullMask';
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import toastr from 'toastr';

export default function Exercises() {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [exercises, setExercises] = useState([]);
    const token = searchParams.get("token");
    useEffect(() => {
        if (!token) return;
        API.post("get-exercises/", {
            token: token
        })
            .then(res => {
                setLoading(false);
                setExercises(res.data);
            })
            .catch(error => {
                console.log(error)
                if (error.response?.status === 400) {
                    toastr.error("Token không hợp lệ!");
                }
            })
    }, [token])
    if (!token) {
        return <NotFound />
    }
    return loading ? <FullMask /> : <>
        <Collapse items={exercises.map(item => ({
            key: item.id,
            label: item.question,
            children: <Essay data={item} setExercises={setExercises} editable={true} token={token} />
        }))} />
    </>
}